import React, {useEffect, useState } from 'react'
import Modal from 'components/modal'
import { validateSurveyIdWithError, validate } from 'shared/helpers/validate'
import 'less/edit-survey-id-modal.less' 

const  EditSurveyIdModal = props => {
  const [surveyId,setSurveyId] = useState(props.currentProject.externalSurveyId)
  const [enableSubmit,setEnableSubmit] = useState(false)
  const [showError,setShowError]=useState(false)

  useEffect(() =>{
    if(surveyId !== props.currentProject.externalSurveyId ){
      setEnableSubmit(true)
    } else {
      setEnableSubmit(false)
    }
  },[surveyId])

  const handleSubmit = () => {
    const validateSurveyId = validate(validateSurveyIdWithError, surveyId)
    if(validateSurveyId.isValid) {
      setShowError(false)
      props.openConfrimEditSurveyIdModal(surveyId)
    } else {
      setShowError(true)
    }
  }

  useEffect (() => {
    setShowError(false)
  },[surveyId])
  
  return (
    <Modal
        title={"EDIT SURVEY ID"}
        isOpen={props.isOpen}
        className="edit-survey-id-modal"
        type="modal"
        autoFocusSubmit={false}
        submitBtnText="Edit Survey ID"
        onCancel={props.onClose}
        onSubmit= {handleSubmit}
        isSubmitting= {props.isSubmitting}
        enableSubmit= {enableSubmit}
      >
      <p>{props.t('edit.survey.id.messgae')}</p>
      <div className={`survey-id-container${showError ? "-error" : ""}`}>
        <div className="survey-id-title">
          <span>{props.t('survey.id.title')}</span>
        </div>
        <input
          className="project-input"
          value={surveyId}
          inputmode="numeric"
          onChange={(e) => setSurveyId(e.target.value)}
        />
        {showError && <div className="error-message"> { props.t('edit.survey.id.error.message') }</div>}
        </div>
      </Modal>
    )
}

export default EditSurveyIdModal
